<template>
    <div class="leaderCustomerReceive">
        <van-nav-bar
            title="客户应收"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
            @click-right="showFilterPop = true"
        >
            <template #right>
                <img class="shaixuan" src="../../../../assets/images/leadingCockpit/shaixuan.png">
            </template>
        </van-nav-bar>
        <filterConditions
            :show-filter-pop.sync="showFilterPop"
            @sureBack="sureBack"
        ></filterConditions>
        <div>
            <van-search v-model="searchValue" placeholder="请输入客户名称查询" @search="handleSearch"></van-search>
        </div>
        <div class="btns">
            <template v-for="(item, index) in timeType">
                <button
                    :class="{'active': selectType == index}"
                    @click="switchingTimeType(index)"
                    :key="index"
                >
                    {{ item.name }}
                </button>
            </template>
        </div>
        <div class="time-select-con" v-if="selectType == 2">
            <div class="time-select">
                <span class="iconfont iconshijian"></span>
                <span class="time" @click="handleShowCalendar(1)">{{ startTime }}</span>
                <span class="split-line"></span>
                <span class="iconfont iconshijian"></span>
                <span class="time" @click="handleShowCalendar(2)">{{ endTime }}</span>
            </div>
        </div>
        <div :class="['list-con van-pull-refresh', {'sectionHeight': selectType == 2}]">
            <ul v-if="list.length>0">
                <li v-for="(item, index) in list" :key="index" @click="toDetail(item)">
                    <h4>客户名称:{{ item.client_name }}</h4>
                    <div class="static-block">
                        <div class="static-item">
                            <div class="num">
                                {{ item.loans_receivable }}
                            </div>
                            <div class="lable">
                                累计应收(元)
                            </div>
                        </div>
                        <div class="static-item">
                            <div class="num">
                                {{ item.official_receipt }}
                            </div>
                            <div class="lable">
                                累计实收(元)
                            </div>
                        </div>
                        <div class="static-item">
                            <div class="num">
                                {{ item.balance }}
                            </div>
                            <div class="lable">
                                当前应收余额(元)
                            </div>
                        </div>
                    </div>
                    <div class="customer-con">
                        <div class="customer-item">
                            <img src="./../../../../assets/images/icons/icon_gy_1.png">
                            <span class="contract-link">合同数量:{{ item.contract_num }}</span>
                        </div>
                        <div class="customer-item">
                            <img src="./../../../../assets/images/icons/icon_2.png">
                            <span class="project-name">工程名称:{{ item.engineering_names }}</span>
                        </div>
                        <div class="customer-item ">
                            <img src="./../../../../assets/images/icons/icon_gy_8.png">
                            <span class="project-name">供货企业:{{ item.tenant_names }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <van-loading size="24px" vertical v-show="loading">
                加载中...
            </van-loading>
            <div class="no-data" v-show="!loading&&list.length==0">
                暂无数据
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择时间"
                :min-date="minDate"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import filterConditions from '../filterConditions/index';

export default {
    name: 'data-customer-receive',
    components: {
        filterConditions,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path === '/dataReport') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'data-customer-receive');
        }
        next();
    },
    data() {
        return {
            loading: true,
            showFilterPop: false,
            searchValue: '',
            startTime: '',
            endTime: '',
            choseTimeType: 0,
            showCalendarPop: false,
            currentDate: '',
            // 时间控件最小时间
            minDate: new Date(2000, 0, 1),
            list: [],
            isLoading: false,
            // 时间类型
            timeType: [{
                name: '当前',
                val: 0,
            }, {
                name: '本年',
                val: 1,
            }, {
                name: '时间段',
                val: 2,
            }],
            // 选中时间类型
            selectType: 0,
            filterData: {},
        };
    },
    watch: {
        selectType(newVal) {
            if (newVal === 0) {
                this.startTime = '';
                this.endTime = '';
                this.handleReceivableClient();
            } else if (newVal === 1) {
                const nweYear = new Date().getFullYear();
                this.startTime = nweYear + '-01-01';
                const newToday = this.formatDate();
                this.endTime = newToday;
                this.handleReceivableClient();
            } else if (newVal === 2) {
                const nweYear = new Date().getFullYear();
                this.startTime = nweYear + '-01-01';
                const newToday = this.formatDate();
                this.endTime = newToday;
            }
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        // 初始化
        init() {
            this.beginDate = '';
            // this.beginDate = '2000-01-01';
            // const newToday = this.formatDate();
            this.endDate = '';
            this.handleReceivableClient();
        },
        sureBack(params) {
            this.filterData = params;
            this.handleReceivableClient();
        },
        // 搜索
        handleSearch() {
            this.handleReceivableClient();
        },
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转到详情页
        toDetail(item) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'dataCustomerReceiveDetail',
                params: {
                    clientId: item.client_id,
                    selectType: this.selectType,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    client_name: item.client_name,
                    yun_yq_id: this.filterData.yun_yq_id,
                    pian_q_id: this.filterData.pian_q_id,
                    qi_y_id: this.filterData.qi_y_id,
                },
            });
        },
        // 处理客户获取应收统计
        async handleReceivableClient() {
            this.loading = true;
            this.list = [];
            const res = await this.receivableClient();
            if (res) {
                this.list = res;
            }
            this.loading = false;
        },
        // 通过客户获取应收统计
        receivableClient() {
            const data = {
                clientId: '',
                clientName: this.searchValue,
                startDate: this.startTime,
                endDate: this.endTime,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            const path = '/interfaceApi/report/account/client_accounts';
            return this.$axios.$post(path, data);
        },
        // 展示日历
        handleShowCalendar(type) {
            if (type === 1) {
                this.currentDate = new Date(this.startTime);
            } else {
                this.currentDate = new Date(this.endTime);
            }
            this.choseTimeType = type;
            this.showCalendarPop = true;
        },
        // 确认时间选择
        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.choseTimeType === 1) {
                const newDate = this.formatDate(value);
                this.startTime = newDate;
            } else {
                const newDate = this.formatDate(value);
                this.endTime = newDate;
            }
            this.handleReceivableClient();
        },
        // 取消时间选择
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 切换时间段类型
        switchingTimeType(index) {
            this.selectType = index;
        },
        // 时间格式化
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            M = M < 10 ? '0' + M : M;
            D = D < 10 ? '0' + D : D;
            return Y + '-' + M + '-' + D;
        },
    },
};
</script>

<style lang="stylus">
.leaderCustomerReceive
    height 100%
    .van-nav-bar__right
        right 15rpx!important;
        width 0
        .shaixuan
            width 18rpx;
    .btns
        display flex
        margin 15rpx
        button
            width 90rpx
            height 30rpx
            color #666666
            margin 0 15rpx
            font-size 14rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            background #fff
            box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
            &.active
                color #fff
                border-color #0E84FF
                background #3495FB
                box-shadow 2px 2px 8px #5494F3
    .time-select-con
        padding 0 15rpx 12rpx 15rpx
    .time-select
        box-shadow 2px 2px 8px rgba(84, 148, 243, 0.2)
        border-radius 4rpx
        border 1px solid #D7D7D7
        height 36rpx
        line-height 36rpx
        display flex
        justify-content center
        .split-line
            width 12px
            background-color #979EA7
            height 1px
            display inline-block
            margin 18rpx 0 0 5rpx
        .time
            font-size 13rpx
        .iconshijian
            color #979EA7
            margin 0 6rpx
    .list-con
        padding 0 15rpx 0 15rpx
        height calc(100% - 146rpx)
        overflow-y auto
        &.sectionHeight
            height calc(100% - 196rpx)
        .no-data
            font-size 28rpx
            line-height 200rpx
            text-align center
            color #ccc
        li
            background #FFFFFF
            box-shadow: 1px 1px 4rpx 0 rgba(84, 148, 243, 0.5)
            border-radius 4rpx
            border 1px solid #D7D7D7
            margin-bottom 15rpx
            h4
                height 40rpx
                background rgba(85, 136, 241, 0.06)
                border-radius 4rpx 4rpx 0 0
                line-height 40rpx
                font-size 14rpx
                padding-left 15rpx
            .static-block
                display flex
                flex-shrink 0
                border-bottom 1px solid #f0f0f0
                padding 10rpx
                .static-item
                    flex 1
                    width 33.33%
                    padding-left 5rpx
                    .num
                        font-size 16rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        color #666666
                    .lable
                        font-size 12rpx
                        color #979EA7
                    &:nth-child(1)
                        padding-top 5rpx
                    &:nth-child(2)
                        padding-top 5rpx
                    &:nth-child(3)
                        background rgba(250, 132, 54, 0.06)
                        padding 5px
                        .num
                            color #FF6600
                        .lable
                            color #666
    .customer-con
        padding 15rpx 15rpx 0 15rpx
        .customer-item
            display flex
            align-items flex-start
            margin-bottom 10rpx
            img
                width 16rpx
                height 16rpx
                margin-right 5rpx
            .contract-link
                font-size 14rpx
                color #419DFF
                text-decoration underline
            .project-name
                font-size 14rpx
                color #666
</style>
